import factory from './icon';
import svgDripdry from './Glyphs/washcare/Dripdry.svg';
import svgDryclpetr from './Glyphs/washcare/Dryclpetr.svg';
import svgDryflat from './Glyphs/washcare/Dryflat.svg';
import svgHandwash from './Glyphs/washcare/Handwash.svg';
import svgIronH from './Glyphs/washcare/IronH.svg';
import svgIronL from './Glyphs/washcare/IronL.svg';
import svgIronM from './Glyphs/washcare/IronM.svg';
import svgLinedry from './Glyphs/washcare/Linedry.svg';
import svgNobleach from './Glyphs/washcare/Nobleach.svg';
import svgNodrycl from './Glyphs/washcare/Nodrycl.svg';
import svgNoIron from './Glyphs/washcare/NoIron.svg';
import svgNotumble from './Glyphs/washcare/Notumble.svg';
import svgNowash from './Glyphs/washcare/Nowash.svg';
import svgTumbleH from './Glyphs/washcare/TumbleH.svg';
import svgTumbleL from './Glyphs/washcare/TumbleL.svg';
import svgTumbleM from './Glyphs/washcare/TumbleM.svg';
import svgTempWash from './Glyphs/washcare/Temp-Wash.svg';

export const IconDripdry = factory(svgDripdry, 24, 24);
export const IconDryclpetr = factory(svgDryclpetr, 24, 24);
export const IconDryflat = factory(svgDryflat, 24, 24);
export const IconHandwash = factory(svgHandwash, 24, 24);
export const IconIronH = factory(svgIronH, 24, 24);
export const IconIronL = factory(svgIronL, 24, 24);
export const IconIronM = factory(svgIronM, 24, 24);
export const IconLinedry = factory(svgLinedry, 24, 24);
export const IconNobleach = factory(svgNobleach, 24, 24);
export const IconNodrycl = factory(svgNodrycl, 24, 24);
export const IconNoIron = factory(svgNoIron, 24, 24);
export const IconNotumble = factory(svgNotumble, 24, 24);
export const IconNowash = factory(svgNowash, 24, 24);
export const IconTumbleH = factory(svgTumbleH, 24, 24);
export const IconTumbleL = factory(svgTumbleL, 24, 24);
export const IconTumbleM = factory(svgTumbleM, 24, 24);
export const IconTempWash = factory(svgTempWash, 24, 24);
